import { ReactQueryDevtools } from '@tanstack/react-query-devtools'
import { createRouter, RouterProvider } from '@tanstack/react-router'
import * as axios from 'axios'
import { StrictMode } from 'react'
import ReactDOM from 'react-dom/client'
import QueryProvider from '@/components/providers/query-provider.tsx'
import { Toaster } from '@/components/ui/sonner'
import { AuthProvider, useAuth } from '@/features/authentication/components/auth-provider.tsx'
import { ModuleProvider } from '@/features/module-switch/module-context'
import { API_URL } from '@/lib/env'
import reportWebVitals from './reportWebVitals.ts'
// Import the generated route tree
import { routeTree } from './routeTree.gen'
import './styles.css'

// Create a new router instance
export const router = createRouter({
  routeTree,
  context: {
    auth: undefined!,
  },
  defaultPreload: 'intent',
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
})

// Register the router instance for type safety
declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

function App() {
  axios.default.defaults.baseURL = API_URL
  const auth = useAuth()
  return <RouterProvider router={router} context={{ auth }} />
}

// Render the app
const rootElement = document.getElementById('app')
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement)
  root.render(
    <StrictMode>
      <QueryProvider>
        <AuthProvider>
          <ModuleProvider>
            <App />
          </ModuleProvider>
        </AuthProvider>
        <ReactQueryDevtools initialIsOpen={false} />
      </QueryProvider>
      <Toaster
        richColors
        position="top-center"
      />
    </StrictMode>,
  )
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example, reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
